class ProductOption extends HTMLElement {
  connectedCallback() {
    this.addEventListener("change", (e) => {
      const selectedValue = this.querySelector(
        ".product-form__option-selected-value",
      );
      if (selectedValue) {
        selectedValue.textContent = e.target.dataset.optionValue;
      }
    });
  }
}

if (!customElements.get("product-option")) {
  customElements.define("product-option", ProductOption);
}
